import { DeliveryTypeCategory } from '@/features/orders/constants/app'

export const deliveryTypeCategories = {
    [DeliveryTypeCategory.Delivery]: 'Rozvoz jídla',
    [DeliveryTypeCategory.Takeaway]: 'Jídlo s sebou',
    [DeliveryTypeCategory.EatIn]: 'Na místě',
}
